import script from "./DiamondDetailCut.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiamondDetailCut.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__